import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router';
import utils from '@/utils';
import 'intersection-observer';
import filters from '@/utils/filters';
filters(Vue);
import Popup from '@/components/popup';
Vue.use(Popup);
import YSF from '@neysf/qiyu-web-sdk';
// YSF.init('27de657ce9048925af6f45ce9445d887',{});
console.log("VUE_APP_YSF_SDK",process.env,1)
YSF.init(process.env.VUE_APP_YSF_SDK||'27de657ce9048925af6f45ce9445d887',{
	hidden:1
}).then(ysf => {
	 let userInfo = store.state.userInfo || utils.getItem("userInfo");
	 console.log("用户信息",userInfo)
  // ysf('open');
  let toysf=(t)=>{
	 
	  let userInfo = store.state.userInfo || utils.getItem("userInfo");
	  console.log("用户信息2",userInfo)
	  // 顾客信息
	  if(userInfo){
		  let options={
		  	  uid:userInfo.pos_id,
		  	  name:userInfo.name,
		  	  mobile:userInfo.phone
		  }
		  ysf('config', options)
	  }
	  // 商品信息
	  if((window.location.pathname=='/detail'||window.location.pathname=='detail')&&t==2){
		// 读取缓存中数据
		if(window.sessionStorage.getItem("qiyu_good_info")){
			try{
				let info=JSON.parse(window.sessionStorage.getItem("qiyu_good_info"))
				if(window.parent !== window){
						  console.log("window.parent",window.parent)
						 var data = {
						   // 要发送到七鱼的商品或者订单的数据对象
						  title: info.product_name,
						  desc: info.product_desc,
						  note: '￥'+info.originalPrice,
						  picture: info.pc_kv_image,
						  url: window.location.origin+'/detail?id='+info.id,
						  goodsId:info.id,//商品ID
						  // sendByUser: 1,
						  // cardType:0,
						  showCustomMsg:1,
						 }
						 console.log("客服发送-",data)
						 window.parent.postMessage(data, '*')
						 return;
				}
				console.log("七鱼-商品小卡",info)
				let product={
						title: info.product_name,
				        desc: info.product_desc,
				        note: '￥'+info.originalPrice,
				        picture: info.pc_kv_image,
				        url: window.location.origin+'/detail?id='+info.id,
				        goodsId:info.id,//商品ID
				        isShow: 1,
				        sendByUser: 1,
				        extraParam: {
				            // param1: '_$onClickAction事件回调中可能需要的额外参数'
				        }
				}
				console.log("七鱼-商品小卡",product)
				ysf('product', product)

			}catch{}
		}else{
			console.log("没有商品小卡信息-七鱼")
		}
	  }
	 ysf('open')
  }
  Vue.prototype.$toysf=toysf
}).catch(error => {
  console.log('sdk加载失败---', error);
  Vue.prototype.$toysf=()=>{
	  console.log("加载失败",error)
	 
  }
});
import '@/assets/grid2.css';
Vue.config.productionTip = false;
// 
const getMemberTitle = sex => sex == 'M' ? 'Mr' : sex == 'F' ? 'Mrs' : '';
const getMemberLevel = levelIndex => ['not_member', 'orchidée', 'gold', 'platinum'][levelIndex] || '';
// 
const gtmTrackUser = () => {
  if (!window.dataLayer) return false;
  let userInfo = store.state.userInfo || utils.getItem("userInfo");
  window.dataLayer.push({
    visitorID: userInfo?.id || '',
    visitorType: userInfo ? 'client' : 'anonymous',
    visitorFirstPurchaseDate: '',
    visitorAge: userInfo?.birth?.substr(0, 4) || 'n/a',
    visitorGender: getMemberTitle(userInfo?.sex) || '',
    visitorZipCode: '',
    visitorCity: '',
    visitorTransactionsCount: '',
    visitorOptedIn: userInfo ? `E:${userInfo?.email?'True':'False'}|S:${userInfo?.phone?'True':'False'}` : '',
    visitorMembership: getMemberLevel(userInfo?.level),
    visitorPoints: 0,
    visitorEmail: '',
    visitorEmail64: ''
  });
};
  
// function setUrlParams(){
//   let params = ["channel", "entrance"];
//   params.map(param => {
//     if(getUrlParam(param)){
//       window.localStorage.setItem(param, getUrlParam(param))
//     }    
//   })
// }
// function getUrlParam(name) {
//   //封装方法           
//    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); 
//    //构造一个含有目标参数的正则表达式对象           
//    var r = window.location.search.substr(1).match(reg); 
//    //匹配目标参数          
//    if (r != null) return unescape(r[2]);     
//    return null;  //返回参数值        
// }
// setUrlParams();

// 
const pageMapping = {
  'Home': 'Homepage',
  'HairRituel': 'Homepage_Hair_rituel',
  'Landing': 'CMS_Pages',
  // 'Category': 'Product_List',
  // 'Detail': 'Product_Page',
  'Cart': 'Cart1',
  'Checkout': 'cart5',
  'TrialConfirm': '',
  'Register': 'Register',
  'Complete': 'Complete',
  'ImproveInfo': 'ImproveInfo',
  'Myaccount': 'My_Account',
  'MyOrders': 'My_Orders',
  'Club': 'My_Club',
  'Profile': 'My_Profile',
  'Address': 'My_AddressBook',
  'Coupon': 'My_Coupon',
  'History': 'My_Footprint',
  'Favorites': 'My_Favorites',
  'MallList': 'Mall_List',
  'MallHistory': 'Mall_History',
  'OrderPay': 'Order_Pay',
  'LegalStatement': 'Legal_Statement',
  'Privacy': 'Privacy',
  'TermsAndConditions': 'Terms_Conditions',
  'Groupe': 'Groupe',
  'Fondation': 'Fondation',
  'Friedland': 'Friedland',
  'FriedlFriedlandDetailand': 'FriedlFriedlandDetailand',
  'PersonalizedSample': 'Personalized_Sample',
  'GiftCustomization': 'Gift_Customization',
  'FrequentlyAskedQuestions': 'FAQ',
  'MemberClub': 'My_Sisley_Club',
  'StoreFinder': 'Store_Locator'
};
// 
const gtmTrackPage = (route) => {
  // PLP和PDP单独在页面中处理，这里没法处理是不是HR
  if (!window.dataLayer || ['Category', 'Detail'].indexOf(route.name) != -1) return false;
  window.dataLayer.push({
    siteCountry: 'CN',
    siteLanguage: 'CN',
    pageCategory: pageMapping[route.name] || route.name
  });
};
// 品数监测的PID
const toPid = (route) => {
  if (route.name == "Landing") {
    return `Landing-${route.query.key}`;
  } else if ('Category' == route.name) {
    return `Category-${route.params.id}`;
  } else if ('Detail' == route.name) {
    return `Detail-${route.query.id}`;
  } else {
    return {
      'Home': 'Home',
      'HairRituel': 'HairRituel',
      'Cart': 'Cart',
      'Checkout': 'Checkout',
      'TrialConfirm': 'TrialConfirm',
      'Register': 'Register',
      'Complete': 'Complete',
      'ImproveInfo': 'ImproveInfo',
      'Myaccount': 'My_Account',
      'MyOrders': 'My_Orders',
      'Club': 'My_Club',
      'Profile': 'My_Profile',
      'Address': 'My_AddressBook',
      'Coupon': 'My_Coupon',
      'History': 'My_Footprint',
      'Favorites': 'My_Favorites',
      'MallList': 'Mall_List',
      'MallHistory': 'Mall_History',
      'OrderPay': 'Order_Pay',
      'LegalStatement': 'Legal_Statement',
      'Privacy': 'Privacy',
      'TermsAndConditions': 'Terms_Conditions',
      'Groupe': 'Groupe',
      'Fondation': 'Fondation',
      'Friedland': 'Friedland',
      'FriedlFriedlandDetailand': 'FriedlFriedlandDetailand',
      'PersonalizedSample': 'Personalized_Sample',
      'GiftCustomization': 'Gift_Customization',
      'FrequentlyAskedQuestions': 'FAQ',
      'MemberClub': 'My_Sisley_Club',
      'StoreFinder': 'Store_Locator'
    }[route.name] || route.name;
  }
}
// 
let lastYLPid = null;
// 品数监测的PV
const ylTrack = (route) => {
  let userInfo = store.state.userInfo || utils.getItem("userInfo");
  if (window?.YLTrackerz?.track) {
    let trackInfo = { type: 'pageview', uid: userInfo?.id || '', pid: toPid(route) };
    if (lastYLPid == trackInfo.pid) return;
    lastYLPid = trackInfo.pid;
    window.YLTrackerz.track(trackInfo);
  }
}

// 分享参数处理
const shareify = (to, from, next) => {
  // console.info(from, to);
  let isLogin = utils.isLogin();
  let fromUid = from.query.u;
  let toUid = to.query.u;
  // 已登录
  if (isLogin) {
    // 登录接口与个人信息接口返回的用户ID字段不一致
    let userInfo = store.state.userInfo || utils.getItem("userInfo");
    let currUid = userInfo?.id || userInfo?.user_id;
    if (!userInfo || !currUid) {
      next();
    } else {
      if (!fromUid && !toUid) {                                   // 首次打开无分享
        next({ name: to.name, params: { ...to.params }, query: { ...to.query, u: currUid }, hash: to.hash });
      } else if (toUid && toUid != currUid && !fromUid) {         // 首次打开他人分享链接
        utils.setItem('share_uid', toUid);
        next({ name: to.name, params: { ...to.params }, query: { ...to.query, u: currUid }, hash: to.hash });
      } else if (fromUid && !toUid && fromUid == currUid) {       // 站内链接跳转
        next({ name: to.name, params: { ...to.params }, query: { ...to.query, u: currUid }, hash: to.hash });
      } else if (fromUid && !toUid && fromUid != currUid) {       // 未登录 -> 登陆后
        utils.setItem('share_uid', fromUid);
        next({ name: to.name, params: { ...to.params }, query: { ...to.query, u: currUid }, hash: to.hash });
      } else {                                                    // 正常跳转 || 异常情况
        // console.info(from.query, to.query);
        next()
      }
    }
  } else {
    if (toUid && !fromUid) {                                    // 首次打开他人分享链接
      utils.setItem('share_uid', toUid);
      next()
    } else if (fromUid && !toUid && from.name != 'Myaccount') { // 站内链接跳转
      next({ name: to.name, params: { ...to.params }, query: { ...to.query, u: fromUid }, hash: to.hash });
    } else {                                                 // 正常跳转 || 异常情况                  
      // console.info(from.query, to.query);
      next()
    }
  }
}


router.beforeEach((to, from, next) => {
  let { title, content, requireAuth, disableLayout, isMaster, isFloating } = to.meta;
  // utm_source 渠道值
  let source = {}, toObj= Object.assign({},to)
  // console.log(to.meta.requireNav)
  if (to.query.utm_source) {
    source.utm_source = to.query.utm_source || ''
    source.utm_medium = to.query.utm_medium || ''
    source.utm_content = to.query.utm_content || ''
    source.utm_campaign = to.query.utm_campaign || ''
    source.utm_term = to.query.utm_term || ''
    store.commit('saveUTMInfo', source)
  }

 if( store.state.utm && store.state.utm.utm_source && !toObj.query.utm_source){
    toObj = Object.assign({}, toObj,{ query: { ...toObj.query, ...store.state.utm } })
    next({ name: toObj.name, params:toObj.params, query: toObj.query, hash: toObj.hash });
  }
  if ((requireAuth && utils.isLogin()) || !requireAuth) {
    utils.setPageInfo(title, content);
    if (isMaster != undefined && isMaster != store.state.isMaster) {
      store.commit('toggleNavType', isMaster);
    }
    store.commit('toggleNavFloating', isFloating === true);
    store.commit('disableLayout', !!disableLayout);
    // 
    shareify(toObj, from, next);
    // GTM
    gtmTrackUser();
    gtmTrackPage(toObj);
    // 
    ylTrack(toObj);
  } else if (requireAuth && !utils.isLogin()) {
    // let { isMaster, isFloating } = from.meta;
    // if (isMaster != undefined && isMaster != store.state.isMaster) {
    //   store.commit('toggleNavType', isMaster);
    // }
    // store.commit('toggleNavFloating', isFloating === true);
    // 1：将登录后跳转页面存入Store中，但需要跳转后及时清理
    // store.commit('saveReturnUrl', encodeURIComponent(to.fullPath));
    // next(false);
    // 2：将登录后跳转页面拼如当前页面地址中，但是退页时面地址会带有returnUrl参数
    if (to.query.returnUrl) {
      console.warn(from, to);
    }
    store.commit('toggleLogin', true);
    next({
      replace: true,
      path: from.fullPath,
      query: {
        returnUrl: encodeURIComponent(to.fullPath)
      }
    });
  } else {
    next();
    // GTM
    gtmTrackUser();
    gtmTrackPage(to);
  }
});

window.vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')